/**
 * Format test case submission error detail for display.
 * Handles backend shape: { title: "error", detail: [ { testcasename, status, message } ] }.
 *
 * @param {*} detail - error.response.data.detail (string or array of items)
 * @returns {string|null} Formatted message for notification, or null if not applicable
 */
export function formatSubmissionErrorDetail(detail) {
  if (detail == null) return null;
  if (Array.isArray(detail) && detail.length > 0) {
    const parts = detail
      .filter((item) => item && typeof item === 'object')
      .map((item) => {
        const name = item.testcasename ?? item.testcase ?? 'Test case';
        const msg = item.message ?? item.msg ?? '';
        return msg ? `${name}: ${msg}` : String(name);
      });
    return parts.length > 0 ? parts.join('; ') : null;
  }
  if (typeof detail === 'string') return detail;
  return null;
}
